import React from 'react';
import SectionSettings from '../SectionSettings';

const AdminEvents = () => <SectionSettings sectionKey="event" />;

export default AdminEvents;
